import { NgModule } from '@angular/core';
import { RouterModule} from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { EmbedDialogComponent } from '@shared/components/embed-dialog/embed-dialog.component';
import { LMSDialogComponent } from '@shared/components/embed-dialog/lms-dialog.component';
@NgModule({
    declarations: [
        EmbedDialogComponent,
        LMSDialogComponent
    ],
    imports: [
        SharedModule,
        RouterModule
    ],
    exports: [
        EmbedDialogComponent,
        LMSDialogComponent
    ]
})
export class EmbedDialogModule { }

